module.exports = __webpack_public_path__ + "static/img/bg-id.1fb55c87.png";